import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Card,
  Form,
  Input,
  Switch,
  Table,
  Row,
  Col,
} from 'antd';
import { isEmpty, set, get, map, isObject, cloneDeep, trim } from 'lodash';

import SurveyCreationModal from './components/SurveyCreationModal';
import HubSelectionModal from './components/HubSelectionModal';

import { setData, saveNewTemplate, deleteTemplate } from './actions';

import './index.scss';

class TemplateForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldError: undefined,
    };
  }

  renderTextRow = (text, record, index) => (
    <div key={index} className="list__table-box">
      {text}
    </div>
  );

  getColumns = () => [
    {
      title: 'Active Launch Groups',
      dataIndex: 'groups',
      key: 'groups',
      render: this.renderTextRow,
    },
    {
      title: 'Active Hubs',
      dataIndex: 'hubs',
      key: 'hubs',
      render: this.renderTextRow,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (text, record, index) => (
        <div key={index} className="list__table-box">
          <Button type="link" onClick={this.toggleHubSelectionModal}>
            Edit
          </Button>
        </div>
      ),
    },
  ];

  getColumnData = ({ isLaunched }) => {
    const { singleTemplate } = this.props;
    const launch_in = get(singleTemplate, ['setting', 'launch_in']);
    if (launch_in && isLaunched)
      return [
        {
          groups: get(launch_in, 'groups') && launch_in.groups.length,
          hubs: get(launch_in, 'hubs') && launch_in.hubs.length,
          id: 1,
        },
      ];

    return [];
  };

  toggleHubSelectionModal = () => {
    const { setData } = this.props;
    setData({ showHubSelectionModal: true });
  };

  toggleModal = () => {
    const { setData } = this.props;
    setData({ showSurveyCreationModal: true, copyFromSurvey: true });
  };

  handleChange = (type, value) => {
    const { singleTemplate, setData } = this.props;
    const { fieldError } = this.state;
    if (type === 'setting.launch') {
      this.toggleHubSelectionModal();
      return;
    }
    if (type === 'templateName' && fieldError && value) {
      this.setState({ fieldError: undefined });
    }
    const clonedTemplate = cloneDeep(singleTemplate);
    set(clonedTemplate, type, value);
    set(clonedTemplate, 'isDirty', true);
    setData({ singleTemplate: clonedTemplate });
  };

  handleSelectionSave = (name, data) => {
    const { setData, singleTemplate } = this.props;
    const clonedTemplate = cloneDeep(singleTemplate);
    set(clonedTemplate, `setting.${name}`, data);
    set(clonedTemplate, 'isDirty', true);
    setData({ singleTemplate: clonedTemplate });
  };

  handleCancel = () => {
    const { setData, history, singleTemplate } = this.props;
    const { isDirty = false } = singleTemplate;
    if (!isDirty) {
      setData({
        showSurveyForm: false,
        surveyData: undefined,
        singleTemplate: undefined,
        preSelectedHubs: [],
      });
    }
    history.push(`/survey-provisioning`);
  };

  handleSave = () => {
    const { surveyData, saveNewTemplate, singleTemplate } = this.props;
    const templateName = get(singleTemplate, 'templateName');
    if (isEmpty(templateName)) {
      this.setState({ fieldError: 'error' });
      return;
    }
    const launch_in = get(singleTemplate, ['setting', 'launch_in'], {});
    const { hubs = [], groups = [] } = launch_in;
    const isLaunched = hubs.length || groups.length;
    const createObj = {
      id: get(singleTemplate, 'id'),
      templateName,
      launch: !!isLaunched,
      launch_in: {
        groups,
        hubs: map(hubs, h => (isObject(h) ? h.key : h)),
      },
      hubId: get(surveyData, 'hubId'),
      surveyId: get(surveyData, 'surveyId'),
    };
    saveNewTemplate(createObj);
  };

  handleDelete = templateId => {
    const { deleteTemplate } = this.props;

    if (!templateId) return;

    deleteTemplate({ templateId });
  };

  saveLaunchIn = ({ selectedGroups, selectedHubs }) => {
    const launch_in = {
      groups: selectedGroups,
      hubs: selectedHubs,
    };
    this.handleSelectionSave('launch_in', launch_in);
  };

  renderDeleteBtn = () => {
    const { singleTemplate } = this.props;

    return (
      <Button
        type="danger"
        onClick={() => this.handleDelete(singleTemplate.id)}
      >
        Delete Template
      </Button>
    );
  };

  render() {
    const {
      showSurveyForm,
      loading,
      singleTemplate = {},
      showHubSelectionModal,
    } = this.props;
    const { fieldError } = this.state;

    if (!showSurveyForm && !get(loading, 'edit_template', false)) return null;

    const templateName = trim(get(singleTemplate, 'templateName', ''));

    const isLaunched =
      get(singleTemplate, 'setting.launch_in.hubs', []).length ||
      get(singleTemplate, 'setting.launch_in.groups', []).length;

    return (
      <>
        <Card
          title="Create Survey"
          className="form"
          bordered={false}
          loading={get(loading, 'edit_template', false)}
        >
          {!singleTemplate.id ? (
            <Button className="form__copy" onClick={this.toggleModal}>
              Copy from other Survey
            </Button>
          ) : null}
          <Form>
            <Form.Item
              name="internal_template_name"
              label="Internal Template Name"
              colon={false}
              required
              validateStatus={fieldError}
              help={`${
                (fieldError && 'Please enter internal template name') || ''
              }`}
            >
              <Input
                value={get(singleTemplate, 'templateName')}
                onChange={event =>
                  this.handleChange('templateName', event.target.value)
                }
              />
            </Form.Item>
            <Form.Item
              name="source_survey_link"
              label="Source Survey Link"
              colon={false}
            >
              <Input disabled value={get(singleTemplate, 'link')} />
            </Form.Item>
            <Form.Item name="survey_name" label="Survey Name" colon={false}>
              <Input value={get(singleTemplate, 'title')} disabled />
            </Form.Item>
          </Form>
          <Card
            title="Launch Survey"
            className="form__card"
            extra={
              <div className="form__card-extra">
                <span>Launched</span>
                <Switch
                  checked={isLaunched}
                  onChange={event => !isLaunched ? this.handleChange('setting.launch', event) : null}
                />
              </div>
            }
            bordered={false}
          >
            <p>
            Launching this survey would copy the template to the chosen hubs or launch groups. 
            It may take several hours for the survey to appear in the selected hubs/launch groups. 
            Once a survey is copied to one or more hubs, it can’t be deleted from this view.
            </p>
            <div className="form__card-table">
              <Table
                locale={{ emptyText: 'Not Launched Yet!' }}
                columns={this.getColumns()}
                dataSource={this.getColumnData({ isLaunched })}
                pagination={false}
                rowkey="launch"
              />
            </div>
          </Card>
          <Row className="form__footer">
            <Col span={17}>
              {singleTemplate.id && !isLaunched ? this.renderDeleteBtn() : null}
            </Col>
            <Col span={7} className="form__footer-right">
              <Button type="ghost" onClick={this.handleCancel}>
                Cancel
              </Button>
              <Button type="primary" onClick={this.handleSave} disabled={isEmpty(templateName)}>
                Save
              </Button>
            </Col>
          </Row>
        </Card>
        <SurveyCreationModal />

        {showHubSelectionModal ? (
          <HubSelectionModal
            launch_in={get(singleTemplate, 'setting.launch_in', {})}
            saveLaunchIn={this.saveLaunchIn}
          />
        ) : null}

      </>
    );
  }
}

const mapStateToProps = ({
  surveyProvisioningReducer: {
    templates,
    loading,
    pagination,
    showSurveyForm,
    surveyData,
    singleTemplate,
    showHubSelectionModal,
  },
}) => ({
  templates,
  loading,
  pagination,
  showSurveyForm,
  surveyData,
  singleTemplate,
  showHubSelectionModal,
});

const mapDispatchToProps = {
  setData,
  saveNewTemplate,
  deleteTemplate,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TemplateForm)
);
